import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ufjltogbaawhqoumefce.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVmamx0b2diYWF3aHFvdW1lZmNlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY0NTU0NjEsImV4cCI6MjA1MjAzMTQ2MX0.0LoYFHNKbB-hady7CT5f1j_p5pFm0FrLfmBx3ZAVUe8';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'Content-Type': 'application/json'
    }
  }
});

// Adiciona listener para erros de conexão
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_OUT') {
    console.warn('Sessão do Supabase expirada ou inválida');
  }
});